interface ValidationErrorResponse {
    type: string;
    title: string;
    status: number;
    errors: Record<string, string[]>;
    traceId: string;
}

export  function parseValidationError(jsonString: string): string[] {
    try {
        const errorObj: ValidationErrorResponse = JSON.parse(jsonString);

        if (errorObj.errors) {
            const messages: string[] = [];

            for (const field in errorObj.errors) {
                if (Array.isArray(errorObj.errors[field])) {
                    messages.push(...errorObj.errors[field].map(msg => `${field}: ${msg}`));
                }
            }

            return messages;
        } else {
            return ['No validation errors found.'];
        }
    } catch (err) {
        return ['Invalid JSON string or unexpected format.'];
    }
}


export function errorHandler(error: any): void {
    console.error("API Error:", error);

    const errArr = parseValidationError(error);
                    
    if (errArr?.length>0  ) {
 
        localStorage.setItem("appErrorMessages", JSON.stringify(errArr));
   //     setErrorMessages(errArr);
 
    } 
 
  }

  export function getError(): string[] {
    const storedErrors = localStorage.getItem("appErrorMessages");
    localStorage.removeItem("appErrorMessages");
    if (storedErrors) {
      try {
        const errArr = JSON.parse(storedErrors) as string[]; 
        return errArr;
      } catch (e) {
        return [];
      }
    }
    return [];

                    
 
  }